import { simpleFetch } from './acCommon'
import moment from "moment";

export const FETCHFUTUREBOOKINGS_REQUEST = 'FETCHFUTUREBOOKINGS_REQUEST'
export const FETCHFUTUREBOOKINGS_SUCCESS = 'FETCHFUTUREBOOKINGS_SUCCESS'
export const FETCHFUTUREBOOKINGS_FAILURE = 'FETCHFUTUREBOOKINGS_FAILURE'

export const FETCHPASTBOOKINGS_REQUEST = 'FETCHPASTBOOKINGS_REQUEST'
export const FETCHPASTBOOKINGS_SUCCESS = 'FETCHPASTBOOKINGS_SUCCESS'
export const FETCHPASTBOOKINGS_FAILURE = 'FETCHPASTBOOKINGS_FAILURE'

export const SUBMITREVIEW_REQUEST = 'SUBMITREVIEW_REQUEST'
export const SUBMITREVIEW_SUCCESS = 'SUBMITREVIEW_SUCCESS'
export const SUBMITREVIEW_FAILURE = 'SUBMITREVIEW_FAILURE'

export const BOOKINGS_UICHANGE = "BOOKINGS_UICHANGE"
export const bookingsUIChange = changes => ({ type: BOOKINGS_UICHANGE, changes })

export const BOOKINGS_METACHANGE = "BOOKINGS_METACHANGE"
export const bookingsMetaChange = changes => ({ type: BOOKINGS_METACHANGE, changes })

export const RESET_BOOKINGS_STATE = "RESET_BOOKINGS_STATE"
export const resetBookingState = () => ({ type: RESET_BOOKINGS_STATE })

export const fetchFutureBookings = () => (dispatch, getState) => {
	let { pageFuture } = getState().metadataReducer.bookings
	let newPage = pageFuture + 1
	let toDate = moment().add(6, 'month').format('DD/MM/YYYY')
	let url = "/customers/bookings/?type=next&page=" + newPage + "&to_date=" + toDate
	let init = { method: 'GET' }
	dispatch(simpleFetch(url, init, 'FETCHFUTUREBOOKINGS'))
		.then(({ actionType, response }) => {
			if(actionType === FETCHFUTUREBOOKINGS_SUCCESS){
				let { metadataReducer: { bookings: { moreBookingsAvailable } } } = getState()
				let newMoreBookingsAvailable = { ...moreBookingsAvailable, future: checkBookingsLeft(response.meta.pagination, newPage) }
				dispatch(bookingsMetaChange({ pageFuture: newPage, moreBookingsAvailable: newMoreBookingsAvailable }))
			}
		})
}

export const fetchPastBookings = () => (dispatch, getState) => {
	let { pagePast } = getState().metadataReducer.bookings
	let newPage = pagePast + 1
	let toDate = moment().subtract(6, 'month').format('DD/MM/YYYY')
	let url = "/customers/bookings/?type=previous&page=" + newPage + "&to_date=" + toDate
	let init = { method: 'GET' }
	dispatch(simpleFetch(url, init, 'FETCHPASTBOOKINGS'))
		.then(({ actionType, response }) => {
			if(actionType === FETCHPASTBOOKINGS_SUCCESS){
				let { metadataReducer: { bookings: { moreBookingsAvailable } } } = getState()
				let newMoreBookingsAvailable = { ...moreBookingsAvailable, past: checkBookingsLeft(response.meta.pagination, newPage) }
				dispatch(bookingsMetaChange({ pagePast: newPage, moreBookingsAvailable: newMoreBookingsAvailable }))
			}
		})
}

const checkBookingsLeft = (pagination, currentPage) => {
	if(pagination.total_pages > currentPage){
		return true
	}
	return false
}

export const fetchMoreBookings = () => (dispatch, getState) => {
	let { type } = getState().metadataReducer.bookings
	if(type === 'future') {
		dispatch(fetchFutureBookings())
	} else {
		dispatch(fetchPastBookings())
	}
}

export const sendReview = ({ grade, comment, booking }) => (dispatch, getState) => {
	if(booking && !booking.review){
		let init = { method: 'PUT', body: JSON.stringify({ rating: grade, review: comment }) }
		let url = "/customers/bookings/" + booking.id + "/review"
		dispatch(simpleFetch(url, init, 'SUBMITREVIEW', { bookingReviewed: booking.id }))
	}
}



// WEBPACK FOOTER //
// ./src/actions/acBookings.js